





























import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import DropDown from '../mixins/Dropdown'
import { every, forEach, toNumber, find } from 'lodash'

@Component
export default class SearchSort extends Mixins(DropDown) {
  @Prop({ default: '分类' }) readonly title!: string
  @Prop({ default: [] }) readonly categoryList!: any
  @Prop({ default: null }) readonly value!: any

  get getValue() {
    if (this.value && this.value.title) {
      if ('全部' === this.value.title) {
        let Index = -1
        for (const index in this.categoryList) {
          for (const val of this.categoryList[index].list) {
            if (this.value.categoryId && this.value.categoryId === val.categoryId) {
              Index = toNumber(index)
              break
            }
          }
          if (Index > -1) break
        }
        if (Index > -1) {
          return this.categoryList[Index].title
        }
      }
      return this.value.title
    }
    return this.title
  }
}
